export default __webpack_public_path__ + "static/helix-ps-1-77c88aca92c69d372b6c6c8d533641bd.jpg";